import isUndefined from 'lodash/isUndefined';
import routes from 'src/router/routes';

export function getMatchingRoute(routeName) {
  return routes[0].children.filter((route) => route.name === routeName)[0];
}

export function isAuthorizedForRoute(route) {
  return (
    isUndefined(route) || isUndefined(route.meta.isAuthorized) || (route.meta.isAuthorized && route.meta.isAuthorized())
  );
}
